// extracted by mini-css-extract-plugin
export default {"noPaddingBottom":"noPaddingBottom---iwy8H"};